import { UmButtonColor, UmButtonVariant } from '../button/button.js';

export interface DialogButtonDef {
  variant?: UmButtonVariant;
  label?: string;
  color?: UmButtonColor;
}
